import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que comprar marcas específicas?',
    a: 'No, la guía te enseña qué ingredientes buscar para que elijas la opción que prefieras.'
  }, {
    q: '¿Es seguro si hago ejercicio?',
    a: 'Es ideal; el ejercicio agota los minerales aún más rápido, este plan te protege.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Los síntomas de deshidratación celular mejoran en 24 horas; la energía profunda se estabiliza en los primeros 10-14 días.'
  }, {
    q: '¿Esto rompe el ayuno?',
    a: 'La guía incluye opciones que respetan el ayuno intermitente.'
  }];
  return <section className="py-24 px-4 bg-white" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <FadeIn data-id="element-122">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-12 text-center" data-id="element-123">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-124">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-125" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={index * 0.1} data-id="element-126">
      <div className="border border-sage rounded-xl overflow-hidden bg-offwhite" data-id="element-127">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-128">
          <span className="font-bold text-forest text-lg pr-4" data-id="element-129">{question}</span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.2
        }} className="text-forest shrink-0" data-id="element-130">
            <ChevronDown size={24} data-id="element-131" />
          </motion.div>
        </button>
        <AnimatePresence data-id="element-132">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-133">
              <div className="px-6 pb-5 text-charcoal/70 leading-relaxed" data-id="element-134">
                {answer}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}